// extracted by mini-css-extract-plugin
export default {"scannerPage":"ScannerPage_scannerPage__SuH-j"};